<template>
    <div>
        <crud-update :open="open" :loading="loading || loadingImpact" :title="title" :errorMessage="errorMessage"
            @update="onUpdateClick" @close="$emit('close')">
            <marca-form ref="form" v-model="form" :input-errors="inputErrors" />
        </crud-update>

        <confirm-dialog v-model="showConfirmImpact" :title="$t('marca.modals.updateImpact.title')"
            :description="impactDescription" confirm-color="primary" max-width="400px" @confirmed="executeUpdate" />
    </div>
</template>

<script>

import MarcaProvider from "../../../providers/MarcaProvider";

import { CrudUpdate, ConfirmDialog } from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";

import MarcaForm from "../MarcaForm";



export default {
    name: "MarcaUpdate",

    components: { MarcaForm, CrudUpdate, ConfirmDialog },

    props: {
        open: { type: Boolean, default: true },
        item: { type: Object, required: true }
    },

    data() {
        return {
            title: 'marca.editing',
            errorMessage: '',
            inputErrors: {},
            loading: false,
            loadingImpact: false,
            showConfirmImpact: false,
            pendingImpact: null,
            form: {
                id: this.item.id,
                nombre: this.item.nombre
            }
        }
    },
    computed: {
        impactDescription() {
            if (!this.pendingImpact) return ''
            const { productosCount, depositosCount } = this.pendingImpact
            const desc = this.$t('marca.modals.updateImpact.description', {
                productosCount,
                depositosCount
            })
            const question = this.$t('marca.modals.updateImpact.confirmQuestion')
            return `${desc} ${question}`
        }
    },
    methods: {
        onUpdateClick() {
            if (!this.$refs.form.validate()) return
            this.loadingImpact = true
            this.errorMessage = ''
            MarcaProvider.getMarcaUpdateImpact(this.form.id)
                .then(r => {
                    if (r?.data?.marcaUpdateImpact) {
                        this.pendingImpact = r.data.marcaUpdateImpact
                        this.showConfirmImpact = true
                    }
                })
                .catch(error => {
                    const clientError = new ClientError(error)
                    this.inputErrors = clientError.inputErrors
                    this.errorMessage = clientError.i18nMessage
                })
                .finally(() => { this.loadingImpact = false })
        },
        executeUpdate() {
            this.loading = true
            this.errorMessage = ''
            MarcaProvider.updateMarca(this.form)
                .then(r => {
                    if (r) {
                        this.$emit('itemUpdated', r.data.marcaUpdate)
                        this.$emit('close')
                    }
                })
                .catch(error => {
                    const clientError = new ClientError(error)
                    this.inputErrors = clientError.inputErrors
                    this.errorMessage = clientError.i18nMessage
                })
                .finally(() => {
                    this.loading = false
                    this.pendingImpact = null
                })
        }
    },
}
</script>

<style scoped></style>
